import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../_store";
import React, { useState } from "react";
import { Col, Card, Modal, Form, Button, Row } from "react-bootstrap";
import { Clipboard2Heart } from "react-bootstrap-icons";
import DeleteButton from "../../../components/DeleteButton";
import { IProduct } from "../../../models/product/IProduct";
import EditButton from "../../../components/EditButton";
import AddButton from "../../../components/AddButton";
import SubmitButton from "../../../components/SubmitButton";
import "./product.css";
import { productAdd, productsGetList, productDelete } from "../../../_store/thunks/product.thunk";
import ProductEdit from "./ProductEdit";
import { ICategory } from "../../../models/ICategory";
import { IMAGE } from "../../../constants/endpoints";

interface IProductsProps {
    setErrorAlert: any;
    category: ICategory | null;
}

interface IDeletionProduct {
    show: boolean;
    product: IProduct | null;
}

export default function Products(props: IProductsProps) {
console.log(props);
    const dispatch = useDispatch<AppDispatch>();
    const allProducts = useSelector((state: RootState) => state.product.products);

    const [showAddProductModal, setShowAddProductModal] = useState<boolean>(false);
    const [deletionProduct, setDeletionProduct] = useState<IDeletionProduct>({ show: false, product: null });

    const [editableProduct, setEditableProduct] = useState<IProduct | null>(null);

    function addProduct(event: any) {
        event.preventDefault();
        if (props.category != null) {
            let name = event.target.name.value;
            let description = event.target.description.value;
            let shortDescription = event.target.shortDescription.value;
            let showInMainPage = event.target.showInMainPage.checked;
            let images = event.target.images.files;

            const formData = new FormData();

            Array.from(images).map((x: any) => formData.append('images', x));
            formData.append("name", name);
            formData.append("description", description);
            formData.append("showInMainPage", showInMainPage);
            formData.append("categoryId", `${props.category.id}`);
            formData.append("shortDescription", shortDescription);

            dispatch(productAdd(formData)).then((x: any) => {
                if (x.error) {
                    props.setErrorAlert(x.error.message);
                }
                else {
                    dispatch(productsGetList())
                    setShowAddProductModal(false);
                }
            });
        }
    }

    function deleteProduct() {
        if (deletionProduct.product) {
            dispatch(productDelete(deletionProduct.product.id)).then((x: any) => {
                if (x.error) {
                    props.setErrorAlert(x.error.message);
                }
                else {
                    dispatch(productsGetList());
                    setDeletionProduct({ show: false, product: null });
                }
            });
        }
    }

    return (
        <>
            {props.category && <>
                <AddButton onClick={() => setShowAddProductModal(true)} size="sm"></AddButton>
                <hr></hr>
                <Row>
                    {allProducts.filter(p => p.categoryId === props.category?.id)?.map((p: IProduct) => (
                        <Col lg={4} md={4} sm={4} xs={4} style={{ paddingBottom: "15px" }} key={p.id}>
                            <Card className="product-card-edit" key={p.id}>
                                <Card.Header style={{ height: "60px" }}>
                                    <EditButton onClick={() => { setEditableProduct(p) }}></EditButton>

                                    <DeleteButton onClick={() => { setDeletionProduct({ show: true, product: p }) }}
                                        size="sm"></DeleteButton>
                                    {p.showInMainPage &&
                                        <h3 style={{ float: "right" }}>
                                            <Clipboard2Heart color="red"></Clipboard2Heart>
                                        </h3>
                                    }

                                </Card.Header>
                                <Card.Img className="product-card-image"
                                    src={`/api/${IMAGE}?id=${p.images[0]}`}></Card.Img>
                                <Card.Body>
                                    <Card.Title>
                                        {p.name}
                                    </Card.Title>
                                </Card.Body>
                            </Card>
                        </Col>))}
                </Row>

                <ProductEdit product={editableProduct} setErrorAlert={props.setErrorAlert} editOnClose={() => setEditableProduct(null)}></ProductEdit>

                <Modal show={showAddProductModal} onHide={() => setShowAddProductModal(false)}>
                    <Modal.Header closeButton>
                        <Modal.Title>Добавить оборудование</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <Form onSubmit={addProduct}>
                            <Form.Group controlId="name">
                                <Form.Label>Название:</Form.Label>
                                <Form.Control type="text" />
                            </Form.Group>

                            <Form.Group controlId="description">
                                <Form.Label>Описание:</Form.Label>
                                <Form.Control as="textarea" rows={4} />
                            </Form.Group>

                            <Form.Group controlId="shortDescription">
                                <Form.Label>Описание (отображается на главной):</Form.Label>
                                <Form.Control as="textarea" rows={3} />
                            </Form.Group>

                            <Form.Group controlId="showInMainPage">
                                <Form.Label>Показывать на главной:</Form.Label>
                                <Form.Check />
                            </Form.Group>

                            <Form.Group controlId="images">
                                <Form.Label>Загрузите изображения:</Form.Label>
                                <Form.Control type="file" multiple accept=".jpef, .png, .jpg" />
                            </Form.Group>
                            <hr></hr>
                            <SubmitButton />
                        </Form>
                    </Modal.Body>
                </Modal>

                <Modal show={deletionProduct.show} onHide={() => setDeletionProduct({ show: false, product: null })}>
                    <Modal.Header closeButton>
                        <Modal.Title>Точно удалить продукцию {deletionProduct.product?.name}?</Modal.Title>
                    </Modal.Header>
                    <Modal.Footer>
                        <Button variant='outline-secondary' onClick={() => setDeletionProduct({ show: false, product: null })}>
                            Отмена
                        </Button>
                        <DeleteButton onClick={() => deleteProduct()} size={undefined} />
                    </Modal.Footer>
                </Modal>
            </>
            }
        </>
    );
}